module.exports = __webpack_public_path__ + "static/media/test18_6.2e2d0cb9.png";